import { StepType, useTour } from '@reactour/tour';
// import Content from 'ui/components/common/Tour/Content';
import { TOUR_SELECTOR } from 'ui/partials/Tour';

const useBeginTutorial = () => {
  const { setIsOpen, setSteps, setCurrentStep } = useTour();

  const beginTutorial: StepType[] = [
    {
      content: 'Click the Help button.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.HELP_BUTTON}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(1), 400);
          },
          false,
        );
      },
      styles: {
        popover: (base) => ({ ...base, marginTop: 29 }),
      },
    },
    {
      content: 'Select a "How to guide"',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.MENU}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setCurrentStep(0);
            setIsOpen(false);
          },
          false,
        );
      },
    },
  ];

  const showQuickCreateBookingSteps = () => {
    setTimeout(() => {
      setSteps?.(beginTutorial);
      setIsOpen(true);
    }, 300);
  };

  return showQuickCreateBookingSteps;
};

export default useBeginTutorial;
